export default "__VITE_ASSET__BK8Kico5__"